import { useLazyQuery } from '@apollo/client'
import { setApproverGroupsList } from 'cache/manage-backup'
import { mapAndFlattenApproverGroups } from 'pages/ManageBackUpPage/ApproverGroupTable/utils/valueMapper'
import { GET_APPROVER_GROUPS_BY_USER } from 'queries/get-approver-groups-by-user'
import {
  ApproverGroupsByUserRequest,
  ApproverGroupsByUserResponse,
} from 'ts/interfaces/approverGroup.interface'

export const useGetApproverGroupsByUser = () => {
  const [getApproverGroupsByUser, { data, loading, error }] = useLazyQuery<
    ApproverGroupsByUserResponse,
    { input: ApproverGroupsByUserRequest }
  >(GET_APPROVER_GROUPS_BY_USER, {
    fetchPolicy: 'no-cache',
    onCompleted: (res) => {
      const mapped = mapAndFlattenApproverGroups(res)
      setApproverGroupsList(mapped ?? [])
    },
    onError: () => {
      setApproverGroupsList([])
    },
  })

  const handleGetApproverGroupsByUser = async (input: ApproverGroupsByUserRequest) => {
    try {
      await getApproverGroupsByUser({
        variables: { input },
      })
    } catch (error) {
      return error
    }
  }
  const mappedData = mapAndFlattenApproverGroups(data)
  return {
    handleGetApproverGroupsByUser,
    loading,
    data: mappedData,
    error,
  }
}
